export default [
    {
        name: 'cadastro-logradouro',
        path: 'logradouro',
        redirect: 'logradouro/index',
        component: () => import(/* webpackChunkName: 'cadastro-logradouro' */ '@/views/cadastro/logradouro/Index'),
        children: [
            {
                meta: {title: 'Lista de logradouros'},
                name: 'cadastro-logradouro-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-logradouro' */ '@/views/cadastro/logradouro/List.vue'),
            },
        ],
    },
]